import { cityQueries } from './GraphQLRequest';
import { authenticatedQuery } from './middleware';

export default {
  fetchAllCities: () => authenticatedQuery(cityQueries.fetchAllCities()),
  fetchCityList: ({ postcode, name }) => authenticatedQuery(cityQueries.fetchCityList(), undefined, { postcode, name }),
  fetchCityListFromPostcode: ({ postcode }) => authenticatedQuery(cityQueries.fetchCityListFromPostcode(), undefined, { postcode }),
};
